<script setup>
  import { shallowRef, defineAsyncComponent, onMounted } from "vue";
  import { storeToRefs } from "pinia";
  import { pascalCase } from "change-case";

  import { useGeneralSetupJobStore } from "@stores/job/setup/generalSetup";

  const { currentFields } = storeToRefs(useGeneralSetupJobStore());

  const components = shallowRef({});

  const determineComponent = (name) =>
    defineAsyncComponent(() => import(`./Fields/${pascalCase(name)}SetupField.vue`));
  const determineComponents = () => {
    components.value = {};
    currentFields.value.forEach((section) => {
      components.value[section.name] = determineComponent(section.name);
    });
  };

  onMounted(() => determineComponents());
</script>

<template>
  <div class="flex flex-col gap-6">
    <div
      v-for="field in currentFields"
      :key="`setup-field-${field.name}`">
      <component
        :is="components[field.name]"
        :label="field.label" />
    </div>
  </div>
</template>
